// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnchorController from "./anchor_controller"
application.register("anchor", AnchorController)

import AutoRemoveController from "./auto_remove_controller"
application.register("auto-remove", AutoRemoveController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ReloadController from "./reload_controller"
application.register("reload", ReloadController)
